import { FormFieldWidget, ModelFieldType, SPI, ViewType } from '@kunlun/dependencies';
import SendGoods from './SendGoods.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Detail,
    ttype: ModelFieldType.String,
    widget: 'SendGoods',
    multi: false
  })
)
export class DetailStringSendGoodsFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(SendGoods);
    return this;
  }
}